import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/(auth)/login/page.tsx");
